import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 7l5 5l-5 5","key":"svg-0"}],["path",{"d":"M13 17l6 0","key":"svg-1"}]]

/**
 * IconPrompt
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcHJvbXB0Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik01IDdsNSA1bC01IDUiIC8+CiAgPHBhdGggZD0iTTEzIDE3bDYgMCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/prompt
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconPrompt = createReactComponent('outline', 'prompt', 'Prompt', __iconNode);

export default IconPrompt;